/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Inbox = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.5 3.5H3.5V14H7.5C8.32843 14 8.99568 14.7116 9.4282 15.4182C9.98035 16.3202 10.9902 17 12 17C13.0098 17 14.0197 16.3202 14.5718 15.4182C15.0043 14.7116 15.6716 14 16.5 14H20.5H22V22H2V2H22V12.5H20.5V3.5ZM20.5 20.5V15.5H16.5064C16.4902 15.5042 16.4358 15.5242 16.339 15.6037C16.1858 15.7294 16.0134 15.9362 15.8511 16.2013C15.0921 17.4413 13.6466 18.5 12 18.5C10.3534 18.5 8.90789 17.4413 8.14886 16.2013C7.98657 15.9362 7.81421 15.7294 7.66104 15.6037C7.56421 15.5242 7.50984 15.5042 7.49361 15.5H3.5V20.5H20.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
